import { render } from "./FeedbackboardPhoneticConsonant.vue?vue&type=template&id=12699f31&scoped=true"
import script from "./FeedbackboardPhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./FeedbackboardPhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/components/feedbackboard-phonetic-consonant.css?vue&type=style&index=0&id=12699f31&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12699f31"]])

export default __exports__